module.exports = __webpack_public_path__ + "static/media/logo-single.dff55da0.png";